import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GEOInputUploadRequest = (filePath, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/GEOInputUpload`,
	params: { filePath, userId }
});

export const GEOInputExportRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RanReportKpis/GEOInputExport`,
	data: { userId }
});
